function ThemeToggle() {
  return null;
}

export default ThemeToggle;
